import { render, staticRenderFns } from "./finance-form.vue?vue&type=template&id=19f42bc4"
import script from "./finance-form.vue?vue&type=script&lang=js"
export * from "./finance-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports